import { create } from "zustand";
import { LOG } from "../utils/logUtil";
import axios from "axios";
import { useAppLoading } from "./useAppLoading";

interface IAppSettings {
  _id?: string;
  dropbotLoadingAd?: string | null;
  dropbotPartnerId?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

interface IStore {
  /** State */
  appSettings: IAppSettings | null;
  updatedSettings?: string | null;
  /** Callbacks */
  getAppSettings: () => void;
  updateAppSettings: (body: Partial<IAppSettings>) => void;
  clearUpdatedSettings: () => void;
}

export const useAppSettings = create<IStore>()((set) => ({
  /** State */
  appSettings: null,
  updatedSettings: null,
  /** Callbacks */
  getAppSettings: async () => {
    useAppLoading.getState().setIsLoading(true);
    try {
      LOG.info("Fetching app settings...");
      const response = await axios.get("app-settings");
      set({ appSettings: response?.data });
    } catch (error) {
      LOG.error("Error on fetching App Settings", { error });
    } finally {
      useAppLoading.getState().setIsLoading(false);
    }
  },
  updateAppSettings: async (body) => {
    useAppLoading.getState().setIsLoading(true);
    try {
      const response = await axios.put("app-settings", body);
      if (response?.data) {
        const updatedSettings = response?.data;
        set({
          appSettings: updatedSettings,
          updatedSettings: updatedSettings._id,
        });
      }
    } catch (error) {
      LOG.error("Error on updating App Settings", { error });
    } finally {
      useAppLoading.getState().setIsLoading(false);
    }
  },
  clearUpdatedSettings: () => {
    set({ updatedSettings: null });
  },
}));